/**
 * Fragment de routes du paquet v2-p05-ecrans-organisation (vague V2). Composants chargés à la demande (règle de
 * chargement du registre).
 *  - Remplacements du socle (`couvre: route:` des YAML) : `/org/utilisateurs` et `/org/invitations` →
 *    organisation-membres ; `/org/utilisateurs/:userId` → organisation-membre-fiche.
 *  - Dialogues en écran plein (routes neuves) : `/org/inviter` (inviter ; `/org/invitations/:invitationId` est réservé à la fiche d'invitation de V8e), et sous la fiche d'un membre
 *    `profils`, `appartenance` (`?type=&id=` en modification), `droit-isole`, `desactivation`, `reactivation`,
 *    `reinitialisation-acces`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationMembres = lazy(() => import('../ecrans/v2/organisation/OrganisationMembres'))
const OrganisationMembreFiche = lazy(() => import('../ecrans/v2/organisation/OrganisationMembreFiche'))
const DialogueInviter = lazy(() => import('../ecrans/v2/organisation/DialogueInviterMembreOrganisation'))
const DialogueProfils = lazy(() => import('../ecrans/v2/organisation/DialogueAttribuerProfilOrganisation'))
const DialogueAppartenance = lazy(() => import('../ecrans/v2/organisation/DialogueAppartenanceMembre'))
const DialogueDroitIsole = lazy(() => import('../ecrans/v2/organisation/DialogueAccorderDroitIsole'))
const DialogueDesactiver = lazy(() => import('../ecrans/v2/organisation/DialogueDesactiverMembre'))
const DialogueReactiver = lazy(() => import('../ecrans/v2/organisation/DialogueReactiverMembre'))
const DialogueReinitialiser = lazy(() => import('../ecrans/v2/organisation/DialogueReinitialiserAccesMembre'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v2-organisation',
  routes: [
    { chemin: '/org/utilisateurs', element: ecran(OrganisationMembres), remplace: true },
    { chemin: '/org/invitations', element: ecran(OrganisationMembres), remplace: true },
    { chemin: '/org/utilisateurs/:userId', element: ecran(OrganisationMembreFiche), remplace: true },
    { chemin: '/org/inviter', element: ecran(DialogueInviter) },
    { chemin: '/org/utilisateurs/:userId/profils', element: ecran(DialogueProfils) },
    { chemin: '/org/utilisateurs/:userId/appartenance', element: ecran(DialogueAppartenance) },
    { chemin: '/org/utilisateurs/:userId/droit-isole', element: ecran(DialogueDroitIsole) },
    { chemin: '/org/utilisateurs/:userId/desactivation', element: ecran(DialogueDesactiver) },
    { chemin: '/org/utilisateurs/:userId/reactivation', element: ecran(DialogueReactiver) },
    { chemin: '/org/utilisateurs/:userId/reinitialisation-acces', element: ecran(DialogueReinitialiser) },
  ],
}
